let siteMenu = $('#site-menu'),
    siteMenuOpen = $('#site-menu-open'),
    siteMenuClose = $('#site-menu-close');

siteMenuOpen.on('click', function() {
    openSiteMenu();
});

siteMenuClose.on('click', function() {
    closeSiteMenu();
});

function openSiteMenu() {
    siteMenu.addClass('active');
    setTimeout(function() {
        siteMenu.addClass('visible');
    }, 10);
}

function closeSiteMenu() {
    siteMenu.removeClass('visible');
    setTimeout(function() {
        siteMenu.removeClass('active');
    }, 310);
}
